import React from 'react';
import { CircularProgress } from '@material-ui/core';

export default function LoadingSpinner() {
  return <CircularProgress size={12} style={{ strokeWidth: 10, marginRight: 10 }} />;
}
